import ImageWithText from "../components/sections/ImageWithText";
import ImageWithTextImage from "../../src/assets/images/AboutUs/hero-about_us.webp";
import GridCircle from "../components/sections/GridCircle";
import GridCircleImage1 from "../../src/assets/images/AboutUs/about_us-intro_1.webp";
import GridCircleImage2 from "../../src/assets/images/AboutUs/about_us-intro_2.webp";
import GridCircleImage3 from "../../src/assets/images/AboutUs/about_us-intro_3.webp";
import GridCircleImage4 from "../../src/assets/images/AboutUs/about_us-intro_4.webp";
import TextAndImageImg from "../../src/assets/images/AboutUs/about_us-eco.webp";
import OurValues from "../components/sections/OurValues";
import TextAndImage from "../components/sections/TextAndImage";
import BrandsGrid from "../components/sections/BrandsGrid";

const ImageWithTextVariables = {
  title: "Quiénes somos",
  useH1: true,
  highlightedText: "Quiénes",

  subtitle: "Un servicio innovador para tu empresa",
  buttonText: "Conócenos",
  href: "#section1",
  image: ImageWithTextImage,
  alt: "trabajador con cinturón de herramientas en un entorno de construcción",
};

const GridCircleVariables = {
  h1: "Revolucionamos el sector del alquiler de herramientas y maquinaria",
  h2: "",
  h2HighlightedText: "herramientas y maquinaria",
  highlightClass: "text-primary block",
  h3: "¡Encuentra el mejor servicio de alquiler de maquinaria y herramientas profesionales!",
  circleItems: [
    {
      image: GridCircleImage1,
      alt: "obrero mirando el móvil sonriendo viendo la página web de elalquilador.com",
      content:
        "Con sólo unos clics compara precios, disponibilidad y características",
    },
    {
      image: GridCircleImage2,
      alt: "persona viendo contenido en el móvil mientras escribe en el ordenador",
      content:
        "Un catálogo online con los proveedores de las principales empresas de alquiler de España",
    },
    {
      image: GridCircleImage3,
      alt: "mano anónima pulsando el botón más de la calculadora de un móvil iphone",
      content: "Ahorra tiempo y dinero",
    },
    {
      image: GridCircleImage4,
      alt: "obrero sonriendo en el trabajo con parte de una grúa amarilla de fondo",
      content:
        "Únete a nuestra comunidad y simplifica el proceso del alquiler de maquinaria",
    },
  ],
};

const TextAndImageVariables = {
  title: "Eco sostenibilidad",
  highlightedText: "Eco",
  content: [
    {
      item: "Desde elalquilador tenemos presente construir un mundo mejor. Por ello tenemos muy interiorizados estos conceptos:",
    },
    {
      item: "El pago por uso implica tener el acceso a productos o servicios en lugar de comprarlos, fomentando la eficiencia y reduciendo la producción para darle una vida más larga a un producto.",
    },
    {
      item: "Con esto pretendemos cubrir el objetivo de maximizar el uso de recursos a través de acciones encaminadas a compartir productos a través del alquiler y, así, minimizar el consumo de materiales vírgenes y reducir el impacto ambiental.",
    },
  ],
  buttonText: "Saber más",
  href: "/sostenibilidad",
  image: TextAndImageImg,
  alt: "Alquiler de maquinaria sostenible y ecológico",
};

function AboutUs() {
  return (
    <>
      <ImageWithText variables={ImageWithTextVariables} />
      <GridCircle variables={GridCircleVariables} />
      <OurValues />
      <TextAndImage variables={TextAndImageVariables} />
      <BrandsGrid />
    </>
  );
}

export default AboutUs;
